import { useTranslation } from "react-i18next";
import { DirectionProvider } from "@radix-ui/react-direction";
import { SUPPORTED_LANGUAGES } from "@/i18n";

/**
 * Propagates `dir` from i18n → Radix primitives (Dropdown, Menu, Popover,
 * Sidebar, Select, Slider, ScrollArea, etc.). Without this, Radix components
 * default to LTR animation/positioning even when the document is RTL, which
 * causes visible jumps and mirrored icons in Arabic.
 *
 * Mount once, high in the tree.
 */
export function DirectionRoot({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const dir =
    SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language)?.dir ?? "ltr";
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
